export function computeScale(containerW, designW){ return containerW / designW }

export function toPathPoints(nodes=[]) {
  return nodes.map(n => ({ x: n.x, y: n.y }))
}

// Quadratic through midpoints (mobile parity)
export function nodesToQuadraticPath(nodes=[]) {
  const pts = nodes.map(n => ({x:n.x,y:n.y}))
  if (pts.length < 2) return ""
  let d = `M ${pts[0].x} ${pts[0].y}`
  for (let i = 1; i < pts.length - 1; i++) {
    const p0 = pts[i]
    const p1 = pts[i + 1]
    const mx = (p0.x + p1.x) / 2
    const my = (p0.y + p1.y) / 2
    d += ` Q ${p0.x} ${p0.y}, ${mx} ${my}`
  }
  const pen = pts[pts.length - 2], last = pts[pts.length - 1]
  d += ` Q ${pen.x} ${pen.y}, ${last.x} ${last.y}`
  return d
}
